import { Modal, Box, Typography } from '@mui/material';
import React, { useState } from 'react';
import styled from 'styled-components';
import { NextButton } from 'src/components/common/CommonStyled';
import { useAdLoginStore } from 'src/stores/AdLoginStore';

const style = {
  position: 'absolute' as const,
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  borderRadius: 2,
  boxShadow: 24,
  padding:'32px',
  width:'calc(100vw - 40px)'
};

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
`

interface Props{
  Open : boolean
  setState : React.Dispatch<React.SetStateAction<boolean>>
}

export default function AdModalBlocked({Open,setState}:Props) {
  const [open, setOpen] = useState(Open);
  const setField = useAdLoginStore((state)=>state.setField)
  const handleClose = () => {
    setOpen(false);
    setState(false)
  }
  const handleOnClick = ()=>{
    setOpen(false);
    setState(false)
    setField('tab','FindPw')
  }
  return (
    <>
      <Modal open={open} onClose={handleClose}>
        <Box sx={style}>
          <span style={{display:'flex',fontSize:'24px',textAlign:'center',width:'100%', justifyContent:'center', fontWeight:600}}>
            비밀번호 5회 실패
          </span>
          <Typography sx={{ mt: 2 , textAlign:'center'}}>
            <span>비밀번호를 5회 틀렸습니다. 비밀번호 찾기를 통해 임시 비밀번호를 발급받고, 새로운 비밀번호를 생성해주세요.</span>
          </Typography>
          <ButtonWrapper>
          <NextButton onClick={handleOnClick} style={{ marginTop: '24px' }}>
            비밀번호 재설정
          </NextButton>
          </ButtonWrapper>
        </Box>
      </Modal>
    </>
  );
}